// extracted by mini-css-extract-plugin
export var center = "_12-2";
export var clickableRow = "_12-5";
export var expandedRow = "_12-7";
export var hoverable = "_12-4";
export var left = "_12-1";
export var right = "_12-3";
export var row = "_12-0";
export var selectedRow = "_12-6";
export var summaryRow = "_12-8";